import { render, staticRenderFns } from "./allreportTable.vue?vue&type=template&id=5efc6024&scoped=true&"
import script from "./allreportTable.vue?vue&type=script&lang=js&"
export * from "./allreportTable.vue?vue&type=script&lang=js&"
import style0 from "./allreportTable.vue?vue&type=style&index=0&id=5efc6024&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efc6024",
  null
  
)

export default component.exports